import React from 'react';
import { useParams } from 'react-router-dom';
import Navigation from '../components/Navigation';
import './IssueDetails.css';

const IssueDetails = () => {

  // Capture the issue_id parameter from the URL
  const { issue_id } = useParams();

  const subdomain = process.env.REACT_APP_SHADOWSTREAM_SUB || 'genflux';

  return (
    <div 
      style={{
        position: "fixed",
        top: 0,
        width: "100%"
      }}
    >
      <div className="IssueDetails">
        <Navigation />
        
        <iframe
          style={{
            marginTop: '20px',
            height: '100vh',
            width: '100%',
            zoom: '0.75',
          }}
          title="inventory-frame"
          src={`https://${subdomain}-taiga.shadowstream.world/project/${subdomain}-tasks/us/${issue_id}`}>
        </iframe>
      </div>
    </div>
  );
};

export default IssueDetails;
